export default {"src":"/_next/static/media/redux.93b22715.svg","height":2383,"width":2500,"blurWidth":0,"blurHeight":0};